module.exports = __webpack_public_path__ + "img/pasencorela.c120ab91.svg";